import React from "react";

import { useGroupByContent } from "../../../hooks";
import { ReportsQueries } from "../../../store/types";
import {
  AutocompleteMultiSelect,
  AutocompleteMultiSelectProps,
  SelectOption
} from "../AutocompleteMultiSelect/AutocompleteMultiSelect";

import "./SetTableColumnBy.styles.scss";

export type DataFormation = Partial<Pick<ReportsQueries, "dealTableColumnBy">>;

const columnByOptions: SelectOption<ReportsQueries["dealTableColumnBy"]>[] = [
  { text: "Investor", key: "Investor", value: "investor" },
  { text: "Measure", key: "Measure", value: "measure" },
  { text: "Date - year", key: "year", value: "year" },
  { text: "Date - quarter", key: "quarter", value: "quarter" },
  { text: "Date - month", key: "month", value: "month" },
  { text: "Date - timeline", key: "timeline", value: "timeline" }
];

interface SetTableGroupByProps {
  onChangeDataFormation?: (dataFormation: DataFormation) => void;
}

export const SetTableColumnBy: React.FC<SetTableGroupByProps> = ({ onChangeDataFormation }) => {
  const fields: Array<keyof ReportsQueries> = ["dealTableColumnBy"];

  const { setFieldValue, values } = useGroupByContent({ fields, onChangeDataFormation });

  const handleChange: AutocompleteMultiSelectProps["onChange"] = (value) => {
    if (value) {
      setFieldValue("dealTableColumnBy", value);
      switch (value) {
        case "year":
        case "quarter":
        case "month":
        case "timeline":
          setFieldValue("dealTableRowBy", "investor");
          setFieldValue("dealTableGroupBy", [["measure"]]);
          break;
        case "investor":
          setFieldValue("dealTableRowBy", "measure");
          setFieldValue("dealTableGroupBy", [["date"]]);
          break;
        case "measure":
          setFieldValue("dealTableRowBy", "investor");
          setFieldValue("dealTableGroupBy", [["date"]]);
          break;
        default:
          setFieldValue("dealTableRowBy", "investor");
          setFieldValue("dealTableGroupBy", [["measure"]]);
      }
    }
  };

  return (
    <div className="group-by-content">
      <div className="group-by-content__title">Select Column By</div>
      <div className="row">
        <div className="input-wrap">
          <AutocompleteMultiSelect
            defaultValue={values.dealTableColumnBy}
            label="Column By"
            disabledClean
            options={columnByOptions}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};
